<template>
  <span>
    <span v-for="(item, index) in items" :key="index">
      <slot v-if="index > 0" name="separator"><span v-html="separator" /></slot>
      <slot :item="item" />
    </span>
  </span>
</template>

<script setup lang="ts">
defineProps({
  items: { type: Array as PropType<any[]>, required: true },
  separator: { type: String, required: false, default: ', ' },
})
</script>
